import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const dtFeederMonitorSlice = createApi({
  reducerPath: 'dtFeederMonitorSlice',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getDtrList: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/asset-management/dt_meter_info/list/`,
        params: params
      }),
      providesTags: ['getDtrList']
    }),
    getFeederList: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/asset-management/feeder_meter_info/list/`,
        params: params
      }),
      providesTags: ['getFeederList']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDtrListQuery, useGetFeederListQuery } =
  dtFeederMonitorSlice;
